 import { useTranslation } from "react-i18next";
import { Button, Card, CardBody, Col, Container, Form, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Nav, NavItem, NavLink } from "reactstrap";
import { H4 } from "../../../../AbstractElements";
import { UserListTableData } from "../../../../data/users/UsersList";
import Select from "react-select";
import { useState, useEffect } from "react";
import { Image } from "../../../../AbstractElements";
import { dynamicImage } from "../../../../service";
import { useParams } from "react-router-dom";
import { customReactSelectStyles } from "../../../../styles/ReactSelectStyles";
import AcessRightDropdown from "./AcessRightDropdown";
import { Href } from "../../../../utils/Constant";
import MasterAccessTab from "./MasterAccessTab";
import Breadcrumbs from "../../../../common-elements/breadcrumbs/Breadcrumbs";



function UserAccessRights() {
  const { t } = useTranslation();
  const { id } = useParams();

  const nameOptions = UserListTableData.map((user) => ({
    value: user.id,
    label: user.name,
    image: user.image,
  }));
  const [basicTab, setBasicTab] = useState("1"); // Set Tab 1 (Organization) as default
  const [selectedUser, setSelectedUser] = useState(nameOptions[0]);
 
  const [modal, setModal] = useState(false);
  const [newRole, setNewRole] = useState("");

  const toggleModal = () => setModal(!modal);
  const userObject = UserListTableData.find((user) => user.id === selectedUser.value);

  const mappedAccessRights = userObject && userObject.acessRights ? userObject.acessRights : {};
 
  const handleAddRole = () => {
    if (newRole.trim()) {
      
      setNewRole("");
      toggleModal();
    }
  };
  useEffect(() => {
    if (id) {
      const found = nameOptions.find((u) => u.value.toString() === id.toString());
      if (found) setSelectedUser(found);
      else setSelectedUser(nameOptions[0]);
    } else {
      setSelectedUser(nameOptions[0]);
    }
  }, [id]);

 
  return (
    <>
      {id ? (
        <Breadcrumbs
          mainTitle={t("AccessRights")}
          parents={[
            { label: t("Users") },
            {
              label: t("organizationAdmin"),
              link: `${process.env.PUBLIC_URL}/users/organization-admin`,
            },
          ]}
        />
      ) : (
        <Breadcrumbs
          mainTitle={t("MasterSetting")}
          parents={[
          
            {
              label: t("AccessRights"),
              link: `${process.env.PUBLIC_URL}/mastersettings/accessrights`,
            },
          ]}
        />
      )}
      <Container fluid>
        <Col xl="12">
          <Card>
            <CardBody>
              {!id && (
                <Nav tabs className="border-tab border-0 mb-0 nav-warning">
                  <NavItem>
                    <NavLink
                      href={Href}
                      className={`nav-border pt-0 txt-warning nav-warning ${basicTab === "1" ? "active" : ""}`}
                      onClick={() => setBasicTab("1")}
                    >
                      <i className="icofont icofont-man-in-glasses"></i>
                      {t("Organizations")}
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      href={Href}
                      className={`nav-border txt-warning nav-warning ${basicTab === "2" ? "active" : ""}`}
                      onClick={() => setBasicTab("2")}
                    >
                      <i className="icofont icofont-file-document"></i>
                      {t("MasterAccess")}
                    </NavLink>
                  </NavItem>
                  {basicTab === "2" && (
            <div className="ms-auto mb-3 d-flex justify-content-end align-items-center">
              <Button color="primary mt-2" onClick={toggleModal}>
                <i className="fa fa-plus me-2" />
                {t("Role")}
              </Button>
            </div>
          )}
                </Nav>
              
              )}
              {basicTab === "1" && (
                <>
                  {id ? (
                    <Col sm="3" className="mb-3">
                      <Label>{t("Name")}</Label>
                      <Select
                        value={selectedUser}
                        placeholder={t("Select Name")}
                        styles={customReactSelectStyles}
                        classNamePrefix="select"
                        isDisabled={true}
                        formatOptionLabel={(option) => (
                          <div className="d-flex align-items-center">
                            <Image
                              src={dynamicImage(option.image)}
                              alt={option.label}
                              style={{ width: 30, height: 30, borderRadius: "50%", marginRight: 8 }}
                            />
                            <span>{option.label}</span>
                          </div>
                        )}
                      />
                    </Col>
                  ) : (
                  
                      <AcessRightDropdown />
                    
                  )}
                  {Object.keys(mappedAccessRights).length > 0 ? (
                    <Col>
                      <Card className="height-equal">
                      <CardBody className="common-flex flex-column switch-wrapper">
                {Object.entries(mappedAccessRights).map(([main, rights]) => (
                  <div key={main} className="mb-4">
                    <H4 className="mb-4">{main}</H4>
                    {Array.isArray(rights) && rights.map((data) => (
                      <div key={data.key} className="d-flex justify-content-between align-items-center mb-2 px-2">
                        <span className="text-start">{data.label}</span>
                        <Label className="switch mb-0">
                          <Input type="checkbox" defaultChecked={data.value} />
                          <span className="switch-state"></span>
                        </Label>
                      </div>
                    ))}
                  </div>
                ))}
              </CardBody>
                      </Card>
                    </Col>
                  ) : (
                    <Col>
                      <div className="text-danger text-center mt-4 mb-4">
                        No user access found for this user.
                      </div>
                    </Col>
                  )}
                </>
              )}
              {basicTab === "2" && !id && (
                <Col>
                   <MasterAccessTab basicTab={basicTab}/>
                </Col>
              )}
              <Modal isOpen={modal} toggle={toggleModal} centered>
        <ModalHeader toggle={toggleModal}>{t("Add New Role")}</ModalHeader>
        <ModalBody>
          <Form>
            <FormGroup>
              <Label for="roleName">{t("Role Name")}<span className="txt-danger">*</span></Label>
              <Input
                type="text"
                id="roleName"
                value={newRole}
                onChange={(e) => setNewRole(e.target.value)}
                placeholder={t("Enter role name")}
              />
            </FormGroup>
          </Form>
          <div className="text-end mt-3">
            <Button
              color="secondary"
              className="me-2"
              type="button"
              onClick={toggleModal}
            >
              {t("Cancel")}
            </Button>
            <Button color="primary" type="submit">
            {t("Add Role")}
            </Button>
          </div>
        </ModalBody>
      </Modal>
            </CardBody>
          </Card>
        </Col>
      </Container>
    </>
  );
}

export default UserAccessRights;